<script setup lang="ts">
import type { BlockForm, Form } from '~/types';
import CmsForm from '~/components/base/CmsForm.vue';

defineProps<{
  data: BlockForm;
}>();
</script>
<template>
  <BlockContainer>
    <div class="max-w-3xl p-8 mx-auto mt-4 bg-submarine-500 dark:bg-submarine-900 rounded-panel">
      <div class="dark:bg-submarine-500 bg-submarine-100 p-4 rounded-md">
        <TypographyTitle v-if="data?.title">{{ data?.title }}</TypographyTitle>
      </div>
      <TypographyHeadline v-if="data?.headline" :content="data?.headline" />
      <CmsForm v-if="data?.form" :form="data?.form as Form" class="mt-4" />
    </div>
  </BlockContainer>
</template>
